import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type UpsertUserFeaturesMutationVariables = Types.Exact<{
  objects: Array<Types.Usertofeatures_Insert_Input> | Types.Usertofeatures_Insert_Input;
}>;


export type UpsertUserFeaturesMutation = { __typename?: 'mutation_root', insert_usertofeatures?: { __typename?: 'usertofeatures_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'usertofeatures', id: number, user_id: number, feature_id: number }> } | null };


export const UpsertUserFeaturesDocument = gql`
    mutation UpsertUserFeatures($objects: [usertofeatures_insert_input!]!) {
  insert_usertofeatures(
    objects: $objects
    on_conflict: {constraint: usertofeatures_feature_id_user_id_key, update_columns: []}
  ) {
    affected_rows
    returning {
      id
      user_id
      feature_id
    }
  }
}
    `;
export type UpsertUserFeaturesMutationFn = Apollo.MutationFunction<UpsertUserFeaturesMutation, UpsertUserFeaturesMutationVariables>;

/**
 * __useUpsertUserFeaturesMutation__
 *
 * To run a mutation, you first call `useUpsertUserFeaturesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUserFeaturesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertUserFeaturesMutation, { data, loading, error }] = useUpsertUserFeaturesMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useUpsertUserFeaturesMutation(baseOptions?: Apollo.MutationHookOptions<UpsertUserFeaturesMutation, UpsertUserFeaturesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertUserFeaturesMutation, UpsertUserFeaturesMutationVariables>(UpsertUserFeaturesDocument, options);
      }
export type UpsertUserFeaturesMutationHookResult = ReturnType<typeof useUpsertUserFeaturesMutation>;
export type UpsertUserFeaturesMutationResult = Apollo.MutationResult<UpsertUserFeaturesMutation>;
export type UpsertUserFeaturesMutationOptions = Apollo.BaseMutationOptions<UpsertUserFeaturesMutation, UpsertUserFeaturesMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/userManagement/queries/upsertUserFeatures.mutation.gql}
 */
export async function upsertUserFeatures(
  variables: UpsertUserFeaturesMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpsertUserFeaturesMutation['insert_usertofeatures']>
export async function upsertUserFeatures(
  variables: UpsertUserFeaturesMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpsertUserFeaturesMutation>
export async function upsertUserFeatures(
  variables: UpsertUserFeaturesMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpsertUserFeaturesMutation['insert_usertofeatures'] | UpsertUserFeaturesMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpsertUserFeaturesMutation>(
    UpsertUserFeaturesDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_usertofeatures
}